export default "/images/vendor/quill/icons/blockquote.svg?928aa5af401fb29fa07515a942ddd4d4";